const faExposure = {
  prefix: 'fal',
  iconName: 'exposure',
  icon: [
    512,
    512,
    [],
    'e2df',
    'M106.7 448q-17.6 0-30.1-12.5T64 405.3l0-298.7q0-17.6 12.5-30.1T106.7 64l298.7 0q17.6 0 30.1 12.5T448 106.7l0 298.7q0 17.6-12.5 30.1T405.3 448l-298.7 0zm0-42.7l298.7 0 0-298.7-298.7 298.7zM309.3 384l0-42.7-42.7 0 0-32 42.7 0 0-42.7 32 0 0 42.7 42.7 0 0 32-42.7 0 0 42.7-32 0zM128 181.3l106.7 0 0-32-106.7 0 0 32z',
  ],
};
export default faExposure;
